import React, { Component } from "react";
import { findIndex } from "lodash";
import DesignTool from "../../designtool";
import FortuneList from "../FortuneList";
import ButtonZoom from "../Button/ButtonZoom";

import {
  EARRINGS_TYPE_ID,
  RING_SIZE_DEFAULT,
  RING_COLOR_DEFAULT,
  MAX_WIDTH_SP,
  CHARM_TYPE
} from "../../const";

export default class DrawTool extends Component {
  constructor(props) {
    super(props);
    this.state = {};
    this.listTouch = [];
  }

  componentDidMount() {
    let elmntWrap = document.getElementById("wrap_draw_tool");
    let perimeter = {
      size: RING_SIZE_DEFAULT,
      color: RING_COLOR_DEFAULT
    };

    let _this = this;

    elmntWrap.addEventListener(
      "touchstart",
      function(e) {
        let tmpList = this.listTouch ? this.listTouch : [];

        tmpList.push(e.changedTouches[0]);
        this.listTouch = tmpList;
      },
      false
    );

    elmntWrap.addEventListener(
      "touchmove",
      function(e) {
        let tmpList = this.listTouch ? this.listTouch : [];
        let { ringIdActive } = _this.props;

        if (tmpList.length === 2 && e.changedTouches.length === 2) {
          let beforeW = Math.sqrt(
            Math.pow(tmpList[0].pageX - tmpList[1].pageX, 2) +
              Math.pow(tmpList[0].pageY - tmpList[1].pageY, 2)
          );
          let afterW = Math.sqrt(
            Math.pow(e.changedTouches[0].pageX - e.changedTouches[1].pageX, 2) +
              Math.pow(e.changedTouches[0].pageY - e.changedTouches[1].pageY, 2)
          );

          this.listTouch = e.changedTouches;
          DesignTool.touchZoom(beforeW, afterW, ringIdActive);
        }
      },
      false
    );

    elmntWrap.addEventListener(
      "touchend",
      function(e) {
        this.listTouch = [];
      },
      false
    );

    setTimeout(() => {
      this.getHeight();
      DesignTool.initialize(1, this.node, perimeter);
      DesignTool.on("onfull", function() {
        _this.genMsgFullMaterial();
      });
      DesignTool.on("onchangecircle", function() {

        _this.genChangeSizeUpMaterial();
      });
    }, 100);
  }

  componentDidUpdate(prevProps, prevState) {
    let {
      isOrientation,
      ringIdActive,
      designInfo,
      productList,
      handleUpdateState
    } = this.props;

    if (isOrientation !== prevProps.isOrientation) {
      let items = [];
      let tmpListMaterial = JSON.parse(localStorage.getItem("materials")) || [];
      let listMaterial = [];

      DesignTool.getItems().map(item => {
        items = [...items, Object.assign({}, item)];
      });

      tmpListMaterial.map(item => {
        listMaterial = [...listMaterial, item];
      });

      localStorage.removeItem("materials");
      handleUpdateState("isUpdateMaterialsTray", true);

      setTimeout(() => {
        this.getHeight();
        var minSize= DesignTool.circleView.ringSizeMin;
        var maxSize= DesignTool.circleView.ringSizeMax;
        DesignTool.initialize(
          ringIdActive,
          document.getElementById("wrap_draw_tool"),
          {
            size: designInfo.ringSize,
            color: designInfo.ringColorCode
          }
        );

        localStorage.setItem("materials", JSON.stringify(listMaterial));
        handleUpdateState("isUpdateMaterialsTray", true);
        DesignTool.circleView.ringSizeMin=minSize;
        DesignTool.circleView.ringSizeMax=maxSize;

        setTimeout(() => {
          if (items.length > 0) {
            for (var i = 0; i < items.length; i++) {
              let index = findIndex(
                productList,
                item => item.id === items[i].productID
              );
              let hookPos = null;

              if (index !== -1 && items[i].productType === CHARM_TYPE) {
                hookPos = {
                  hookW: productList[index].charm_hanger_width,
                  hookX: productList[index].charm_hanger_coord_x,
                  hookY: productList[index].charm_hanger_coord_y
                };
              }

              // update url image
              let n = items[i].imageURL.search(/t=/i);
              let urlImage = "";

              if (n !== -1) {
                urlImage =
                  items[i].imageURL.slice(0, n + 2) + `${new Date().getTime()}`;
              } else {
                urlImage = items[i].imageURL + `?t=${new Date().getTime()}`;
              }

              DesignTool.addItem(
                designInfo.ringSize,
                items[i].angle,
                items[i].sizeID,
                urlImage,
                items[i].imageSize,
                items[i].size,
                items[i].productID,
                items[i].productType,
                hookPos
              );
            }
          }

          handleUpdateState("isLoadingDrawTool", false);
        }, 500);
      }, 400);
    }
  }

  getHeight() {
    let { getWidthBrowser } = this.props;
    let elmnt = document.getElementById("draw_tool_parent");
    let elmntWrap = document.getElementById("wrap_draw_tool");

    if (elmnt) {
      if (elmnt.offsetWidth >= elmnt.offsetHeight) {
        if (MAX_WIDTH_SP > getWidthBrowser()) {
          // fix positon canvas in mobile
          elmntWrap.style.height = `${elmnt.offsetHeight - 40}px`;
        } else {
          elmntWrap.style.height = `${elmnt.offsetHeight}px`;
        }
      } else {
        elmntWrap.style.height = `${elmnt.offsetWidth}px`;
      }
    }
  }

  genMsgFullMaterial() {
    let { handleUpdateState } = this.props;
    let message =
      "現在のデザインの素材の合計サイズが、選択したサイズに達しました。 素材を追加できません。";

    handleUpdateState("isShowDialogMessage", true);
    handleUpdateState("dialogMessage", message);
  }

  genChangeSizeUpMaterial() {
    let {
      designInfo,
      tmpDesignInfo
     // handleUpdateState
    } = this.props;
    designInfo.ringSize=DesignTool.circleView.ringSize;
    tmpDesignInfo.ringSize=DesignTool.circleView.ringSize;
  }

  render() {
    let { ringIdActive } = this.props;

    return (
      <div className="main_content">
        <div className="content_wrap">
          <div className={`draw_tool ${this.props.isShowPopupSp ? 'is_show' : ''}`} id="draw_tool_parent">
            <div
              id="wrap_draw_tool"
              className={`wrap-draw-tool${
                ringIdActive === EARRINGS_TYPE_ID ? "draw_tool_earing" : ""
              }`}
              ref={node => {
                this.node = node;
                return node;
              }}
            />
          </div>
          <FortuneList {...this.props} />
          <ButtonZoom {...this.props} />
        </div>
      </div>
    );
  }
}
